import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgBrowser24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Browser",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.75 2H4.25A2.25 2.25 0 0 0 2 4.25v15.5A2.25 2.25 0 0 0 4.25 22h15.5A2.25 2.25 0 0 0 22 19.75V4.25A2.25 2.25 0 0 0 19.75 2M4.25 3.5h15.5a.75.75 0 0 1 .75.75v3.827h-17V4.25a.75.75 0 0 1 .75-.75m15.5 17H4.25a.75.75 0 0 1-.75-.75V9.577h17V19.75a.75.75 0 0 1-.75.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.46 6.48a.75.75 0 0 0 .82-1.22.774.774 0 0 0-1.06 0 .75.75 0 0 0 .24 1.22M5.22 6.32a.75.75 0 1 0 .24-1.22.75.75 0 0 0-.24 1.22M11.75 6.539h6.5a.75.75 0 0 0 0-1.5h-6.5a.75.75 0 0 0 0 1.5"
}));

export { SvgBrowser24 as default };
//# sourceMappingURL=Browser24.js.map
